import type { OnDestroy } from '@angular/core';
import { Injectable } from '@angular/core';

import type { Observable, Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { I18nService } from '@core/i18n-legacy';
import type { EditorEvent } from '@core/prosemirror-legacy';
import { ImageSizeExceeded, ImageUploadError } from '@core/prosemirror-legacy';
import { NotificationsController } from '@core/user-interface-legacy';

@Injectable()
export class WysiwygToastService implements OnDestroy {
  private readonly maxSize = '50MB';

  private subscription: Subscription;
  private onDestroy$ = new Subject<void>();

  constructor(
    private notification: NotificationsController,
    private i18n: I18nService,
  ) {}

  public ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  public init(eventStream$: Observable<any>) {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = eventStream$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(event => this.onEvent(event));
  }

  private onEvent(event: EditorEvent) {
    if (event instanceof ImageSizeExceeded) {
      this.notification.error(
        this.i18n.translate('wysiwyg.image_plugin.size_exceeded_error', { size: this.maxSize }),
      );
    }
    if (event instanceof ImageUploadError) {
      this.notification.error(event.type);
    }
  }
}
